import styled from "styled-components";
import React from "react";

const UnStyledResultMessageText = styled.p`
  color: ${props => props.success ? 'green' : '#dc3545'};
  white-space: pre-line;
`;

const ResultMessageText = ({success, text, ...props}) => {
    if (text) {
        return (
            <UnStyledResultMessageText {...props} success={success}> {text} </UnStyledResultMessageText>
        );
    }
    return null;
};

export default ResultMessageText;